import Dialog from './Dialog';
import  Form, { Send, CardForm, DialogForm, FormOverlay } from './Form';
import Groupbox from './GroupBox';
import Table from './Table';
//@ts-ignore
import Confirm from './Dialog/Confirm.vue'

export {
    Dialog,
    Confirm,
    Send,
    Form,
    CardForm,
    DialogForm,
    FormOverlay,
    Groupbox,
    Table
};